import { FC } from 'react';
import styled from 'styled-components';
import { Icon } from '../../Icon/Icon';

const NavMenuItemElement = styled.div`
  display: flex;
  border-radius: 5px;
  height: 34px;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};

  .active &,
  :hover {
    background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
    font-weight: bold;
  }
`;

const TitleElement = styled.span`
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  margin: auto 0px;
  white-space: nowrap;
`;

const IconElement = styled.div`
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  width: 15px;
  margin: auto 10px;

  svg {
    /* hate it but need it to override FA and match designs */
    width: 15px !important;
  }
`;

export interface IProps {
  /** Icon style for entry item */
  icon?: string;
}

export const SubNavLink: FC<IProps> = ({ icon, children }) => (
  <NavMenuItemElement data-testid="SubNavEntry">
    <IconElement>
      <Icon icon={icon} />
    </IconElement>

    <TitleElement>{children}</TitleElement>
  </NavMenuItemElement>
);
